import React from "react";
import IconButton from 'material-ui/IconButton';

const styles = {
  buttonStyle: {
    position: "absolute",
    top: 0,
    right: 0
  }
};

export default class RightArrowIcon extends React.Component {

  render() {
    const {onToggleTapped, isExpanded, color} = this.props;
    const buttonType = isExpanded ? <ArrowUpIcon color={color} /> : <ArrowDownIcon color={color} />;
    return <IconButton style={styles.buttonStyle} onClick={()=>onToggleTapped(isExpanded)}>
      {buttonType}
    </IconButton>;
  }
};

const ArrowUpIcon = props => {
  const color = props.color;
  return (
    <svg width={23} height={20} {...props}>
      <title>arrow up</title>
      <path fill={color} d="M7 14l5-5 5 5z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
  );
};

const ArrowDownIcon = props => {
  const color = props.color;
  return (
    <svg width={23} height={20} {...props}>
      <title>arrow down</title>
      <path fill={color} d="M7 10l5 5 5-5z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
  );
};




// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/RightArrowIcon.js